import { BarcodeScanner } from '@capacitor-mlkit/barcode-scanning';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { Device } from '@capacitor/device';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonLoading,
  IonModal,
  IonPage,
  IonPopover,
  IonSelect,
  IonSelectOption,
  IonSpinner,
  IonTitle,
  IonToolbar,
  useIonToast,
} from '@ionic/react';
import { MenuItem, Select } from '@material-ui/core';
import { barcodeOutline, barcodeSharp, close, constructOutline, createOutline, informationCircle, } from 'ionicons/icons';
import React, { useState, useEffect, useContext } from 'react';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Barcode from 'react-barcode';
import { useTranslation } from 'react-i18next';
import { Link, useHistory, useLocation } from 'react-router-dom';
import TimeAgo from 'timeago-react';

import axios from '../../axios';
import Header from '../../components/Header';
import { createAssetFields } from '../../models/createAssetFields';
import { AppContext } from '../../providers/AppContext';
import { checkIfArraysAreSame, getSetAssetCategory, getSetAssetType, isFormDataEmpty, requestPermissions } from '../../utils';



const AssetDet: React.FC = () => {
  const { state } = useContext(AppContext);
  const location = useLocation();
  const [present] = useIonToast();
  const [showLoading, setShowLoading] = useState(false);

  const [timeline, setTimeline] = useState([]);
  const [quickupdate, setQuickupdate] = useState(false);
  const [pname, setPname] = useState('');
  const [loaderM, setLoaderM] = useState(false);
  const [showQr, setShowQr] = useState(false);
  const [color, setColor] = useState<any>('');
  const [asToggle, setAsToggle] = useState(false);

  const [data, setData] = useState<any>({
    asset_name: '',
    name: '',
  });

  const [primaryData, setPrimaryData] = useState<any>({});

  const [update, setUpdate] = useState<any>({
    status: '',
    asset_state: '',
    brand: '',
    model: '',
    year: '',
    comment: '',
    asset_component: [],
    attachment: {},
    barcode_id: '',
    old_asset: '',
    northing_easting_point: '',
    northing_easting_address: ''
  });
  const [loaderGps, setLoaderGps] = useState(false);

  const { t } = useTranslation();
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [_data, set_Data] = useState<any>(createAssetFields);

  const handleUpdateStatus = (event: any) => {
    const formentry: any = { ...update };

    if (event.target.name in formentry) {

      formentry[event.target.name] = event.target.value;
    }
    setUpdate(formentry);
  };

  const handleChangeQuickUpdate = (event: any) => {
    const formentry: any = { ...update };
    if (event.target.id in formentry) {
      formentry[event.target.id] = event.target.value;
    }
    setUpdate(formentry);
  };

  // const handleMultiSelectChange = (event: string) => {
  //   const formentry: any = { ...update };
  //   formentry['asset_component'] = event
  //   setUpdate(formentry);
  // };


  const handleMultiSelectChangeEdit = (event: any) => {
    const formentry: any = [..._data];
    const f_index = formentry.findIndex((v: any) => v.field === 'asset_component');
    formentry[f_index].value = event;
    set_Data(formentry);
  };


  const getAssetIndividual = () => {
    const res: any = history.location.state;
    axios({
      method: 'get',
      url: `resource/Asset/${res}`,
      headers: {
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
    })
      .then((res) => {
        const temp = res.data.data;
        if (temp?.asset_category) {
          getAssetCategoryColor(temp.asset_category || '')
        }
        setData(temp);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (history?.location?.state)
      getAssetIndividual();
  }, [history.location.state]);


  const getAssetCategoryColor = (asset_category: string) => {
    axios({
      method: 'get',
      url: `resource/Asset Category/${asset_category}`,
      headers: {
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
    })
      .then((res) => {
        setColor(res?.data?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const getTimeline = () => {
    const res: any = history.location.state;
    const url = `/resource/Version?fields=["*"]&filters=[["Version","docname","=","${res}"]]&limit_start=0&order_by=creation%20desc`;
    const config: any = {
      method: 'get',
      url,
      headers: {
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
    };
    axios(config)
      .then((res) => {
        setTimeline(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      })
  };

  useEffect(() => {
    getTimeline();
  }, []);

  const edit = () => {
    callAssetById();
    setShowModal(true);
  };

  const handleChange = (event: any) => {
    const formentry: any = [..._data];
    const f_index = formentry.findIndex((v: any) => v.field === event.target.id);
    const change_form_object = formentry[f_index];
    change_form_object.value = event.target.value;
    formentry[f_index] = change_form_object;
    set_Data(formentry);
  };

  const handleSelectChange = (event: any) => {
    const formentry: any = [..._data];

    const select = event.target.name.replaceAll('-', '_');
    const f_index = formentry.findIndex((v: any) => v.field === select);
    formentry[f_index].value = event.target.value;
    set_Data(formentry);
  };

  // Mapping fields after scan
  const callAssetById = async () => {
    setShowLoading(true);
    /* Get Project by User */
    // const projectList = await getSetProjectList(1);
    /* Get Asset Category */
    const assetCategory = await getSetAssetCategory();
    /* Get Asset Type */
    const assetType = await getSetAssetType();

    const config: any = {
      method: 'get',
      url: `resource/Asset/${data.name}`,
      headers: {
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
    };

    try {
      const res = await axios(config);
      setPrimaryData(res?.data?.data);
      const temp = res.data.data;
      for (const x in createAssetFields) {
        const f = createAssetFields[x].field ? createAssetFields[x].field : '';
        if (f === 'project') {
          createAssetFields[x].value = temp['project'];
          createAssetFields[x].type = 'text';
          createAssetFields[x].disabled = true;
        }
        //  else if (f === 'asset_component') {
        //   const assetComponent: any = []
        //   temp.asset_component.map((item: any) => {
        //     assetComponent.push(item?.asset_component)
        //   })
        //   createAssetFields[x].value = assetComponent
        // } 
        else if (f === 'asset_category' || f === 'asset_type') {
          createAssetFields[x].value = temp[f];
          createAssetFields[x].options = f === 'asset_category' ? assetCategory : assetType;
        } else if (f) {
          createAssetFields[x].value = temp[f];
        }
      }
      set_Data(createAssetFields);
    } catch (error: any) {
      console.log(error);
    } finally {
      setShowLoading(false);
    }

    const Data = [..._data];

    // /* Get Asset Component to link Asset */
    // const acname = Data.findIndex((d) => d.field === 'asset_component');
    // console.log(acname)
    // Data[acname].options = await getAssetComponentByLabel();
    set_Data(Data);
  };

  const Submit = (e: any) => {
    e.preventDefault();
    hitEditAsset();
  };

  const hitEditAsset = async () => {
    const formData = new FormData();
    for (const _entry of _data) {
      if (_entry.field === 'attachment' && _entry['src']) {
        try {
          const response = await fetch(_entry?.src?.toString());
          const blob = await response.blob();
          formData.append(
            'attachment',
            new File([blob], `${data.name}-attachment.${_entry.format}`, {
              type: `image/${_entry.format}`,
            })
          );
        } catch (e: any) {
          console.log(e)
        }
      }
      // else if (_entry.field === 'asset_component') {
      //   if (_entry.value?.length > 0) {
      //     const assComp = [] as any;
      //     for (const element in _entry.value as any) {
      //       assComp.push({

      //         asset_component: _entry.value[element]
      //       })
      //     }

      //     if (!checkIfArraysAreSame(primaryData[_entry.field], assComp))
      //       formData.append('asset_component', JSON.stringify(assComp));
      //   }
      // }
      else if (_entry.field && (primaryData[_entry.field] !== _entry.value)) {
        formData.append(_entry.field, _entry.value as any);
      }
    }

    const config: any = {
      headers: {
        Accept: 'application/json',
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
    };
    if (!isFormDataEmpty(formData)) {
      setShowLoading(true);

      const baseURL = localStorage.getItem('baseUrl') || process.env.REACT_APP_BASE_URL || 'https://admin.hyprism.com/api';
      const urlPart = `method/preflet_asset.api.update_asset/${data.name}`;
      const fetchUrl = urlPart.startsWith('http')
        ? urlPart
        : `${baseURL.replace(/\/+$/, '')}/${urlPart.replace(/^\/+/, '')}`;

      fetch(fetchUrl, {
        method: 'PUT',
        headers: config.headers,
        body: formData,
      })
        .then(async (response) => {
          if (!response.ok && response.status !== 200) {
            const errorText = await response.text();
            throw Object.assign(new Error(), { response: { data: errorText } });
          }
          present({
            message: t('Assets.CreateA.assetUpdateSuccesss'),
            duration: 2000,
          });
          reset();
          setShowModal(false);
          getAssetIndividual();
          getTimeline();
        })
        .catch(function (error) {
          console.log(error?.response?.data);
          present({
            message: 'Try Again',
            color: 'danger',
            duration: 2000,
          });
        })
        .finally(() => {
          setShowLoading(false);
        });
    } else {
      setShowModal(false);
    }
  }


  const reset = () => {
    for (const x in _data) {
      if (_data[x].field === 'attachment') {
        _data[x].src = '';
        _data[x].format = '';
        _data[x].value = '';
      }
      // else if (_data[x].field === 'asset_component') {
      //   _data[x].value = [];
      // } 
      else _data[x].value = '';
    }

    for (const x in createAssetFields) {
      const f = createAssetFields[x].field;
      if (f === 'project') {
        createAssetFields[x].value = '';
        createAssetFields[x].options = [];
        createAssetFields[x].type = 'select';
        createAssetFields[x].disabled = false;
      } else if (f === 'task') {
        createAssetFields[x].value = '';
        /* Get TASK by PROJECT */
        createAssetFields[x].options = [];
      }
    }
  };

  const returnTimeline = (item: any) => {
    if (JSON.parse(item.data).created_by?.length) {
      return (
        <div key={JSON.parse(item.data).created_by.length} className="timeline-container">
          <div className="timeline-dot"></div>
          {/* <span>{name}</span> */}
          <span>
            <b className="text-black">{JSON.parse(item.data).created_by}</b>&nbsp; {t('Utils.created')}{' '}
            <b>{data.asset_name}</b>
          </span>
          <span>
            {' '}
            -{' '}
            <TimeAgo
              datetime={new Date(JSON.parse(item.data).creation.split(' ').join('T') + 'Z').toLocaleString('lt-LT')}
            />
          </span>
        </div>
      );
    } else if (JSON.parse(item.data).added?.length) {
      return JSON.parse(item.data).added.map((element: any, index: number) => {
        return (
          <div key={index} className="timeline-container">
            <div className="timeline-dot"></div>
            <span>
              <b className="text-black">{element[1].owner}</b>&nbsp;{t('Utils.added')}&nbsp;
            </span>
            <span>
              <b className="text-black">{t(`Assets.CreateA.${element[0]}`)}</b>&nbsp;
            </span>
            <span>
              : <b className="text-black">{element[1].component_name}</b>&nbsp;
            </span>
            <span>
              {' '}
              -{' '}
              <b>
                {' '}
                <TimeAgo datetime={new Date(item.modified.split(' ').join('T') + 'Z').toLocaleString('lt-LT')} />
              </b>
            </span>
          </div>
        );
      });
    } else if (JSON.parse(item.data).changed?.length) {
      return JSON.parse(item.data).changed.map((element: any, key: number) => {
        return (
          <div key={key} className="timeline-container">
            <div className="timeline-dot"></div>
            <span>
              <b className="text-black">{element[1]?.owner}</b>&nbsp;{t('Utils.changed')}&nbsp;
            </span>
            <span>
              <b className="text-black">{t(`Assets.CreateA.${element[0]}`)}</b>&nbsp;{t('Utils.from')}&nbsp;
            </span>
            <span>
              <b className="text-black">{element[1] ? element[1] : '--'}</b>&nbsp;{t('Utils.to')}&nbsp;
            </span>
            <span>
              <b className="text-black"> {element[2]}</b>
            </span>
            -
            <TimeAgo datetime={new Date(item.modified.split(' ').join('T') + 'Z').toLocaleString('lt-LT')} />
          </div>
        );
      });
    }
  };
  // const downloadQR = (assetName: string | undefined) => {
  //   const div = document.getElementById('download-qr-code');

  //   if (div instanceof HTMLElement) {
  //     // Extract the inner SVG content from the div
  //     const svgData = div.innerHTML;

  //     const canvas = document.createElement('canvas');
  //     const ctx = canvas.getContext('2d');
  //     const img = new Image();

  //     img.onload = function () {
  //       if (ctx) {
  //         canvas.width = img.width;
  //         canvas.height = img.height;

  //         ctx.drawImage(img, 0, 0);

  //         const pngFile = canvas.toDataURL('image/png');

  //         const downloadLink = document.createElement('a');
  //         downloadLink.download = `${assetName}`;
  //         downloadLink.href = pngFile;
  //         downloadLink.click();
  //       }
  //     };

  //     img.onerror = function (errorEvent) {
  //       console.error('Error loading image:', errorEvent);
  //     };

  //     img.src = 'data:image/svg+xml;base64,' + btoa(svgData);
  //   } else {
  //     console.error('SVG element not found');
  //   }

  // };

  // const printOnlyCode = () => {
  //   const div = document.getElementById('download-qr-code');

  //   if (div instanceof HTMLElement) {
  //     // Extract the inner SVG content from the div
  //     const svgData = div.innerHTML;
  //     // Open a new window
  //     const printWindow = window.open('', '_blank');

  //     if (printWindow) {
  //       // Inject the SVG content into the new window
  //       printWindow.document.write(`
  //           <!DOCTYPE html>
  //           <html>
  //             <head>
  //               <title>Print</title>
  //             </head>
  //             <body>
  //               ${svgData}
  //             </body>
  //           </html>
  //         `);

  //       // Wait for the SVG to load before triggering print
  //       printWindow.document.addEventListener('DOMContentLoaded', () => {
  //         printWindow.print();
  //         printWindow.document.close();
  //       });
  //     } else {
  //       console.error('Failed to open a new window');
  //     }
  //   }
  // }

  const quickStatus = async () => {
    setQuickupdate(true);
    // const Data = [..._data];
    setPrimaryData(data);
    /* Get Asset Component to link Asset */
    // const acname = Data.findIndex((d) => d.field === 'asset_component');
    // Data[acname].options = await getAssetComponentByLabel();
    // set_Data(Data);

    // const assetComponent: { asset_component: any; }[] = []

    // data?.asset_component.map((item: any) => {
    //   assetComponent.push(item?.asset_component)
    // })

    const formentry: any = { ...update };

    formentry.status = data.status
    formentry.asset_state = data.asset_state
    formentry.brand = data.brand
    formentry.model = data.model
    formentry.year = data.year
    formentry.comment = data.comment
    formentry.attachment.value = data.attachment
    formentry.barcode_id = data.barcode_id
    formentry.old_asset = data.old_asset
    // formentry.asset_component = assetComponent
    setUpdate(formentry);
  };

  const SubmitStatusUpdate = async (e: any) => {
    e.preventDefault();
    hitQSupdate();
  };

  const hitQSupdate = async () => {
    const formData = new FormData();
    const temp = { ...update }
    for (const item in temp) {

      if (item === 'attachment' && temp['attachment']?.src) {
        try {

          const response = await fetch(temp['attachment']?.src?.toString());
          const blob = await response.blob();
          formData.append(
            'attachment',

            new File([blob], `${pname}-attachment.${temp['attachment'].format}`, {

              type: `image/${temp['attachment'].format}`,
            })
          );
        } catch (e: any) {
          console.log(e)
        }
      } else if (item === 'asset_component') {
        if (temp[item].length > 0) {
          const assComp = [] as any;
          for (const element in temp['asset_component']) {
            assComp.push({
              asset_component: temp['asset_component'][element]
            })
          }

          if (!checkIfArraysAreSame(primaryData[item], assComp))
            formData.append('asset_component', JSON.stringify(assComp));
        }

      } else if (item === 'attachment' && (primaryData[item] !== temp[item].value)) {

        formData.append('attachment', temp[item].value);

      } else if (temp[item] !== '' && temp[item] !== null && temp[item] !== undefined && temp[item] !== 'undefined') {

        if ((primaryData[item] !== temp[item]) && item !== 'attachment')

          formData.append(item, temp[item]);
      }
    }

    const config: any = {
      headers: {
        Accept: 'application/json',
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
    };
    if (!isFormDataEmpty(formData)) {
      // Update status api
      try {
        setLoaderM(true);

        const baseURL = localStorage.getItem('baseUrl') || process.env.REACT_APP_BASE_URL || 'https://admin.hyprism.com/api';
        const urlPart = `method/preflet_asset.api.update_asset/${pname}`;
        const fetchUrl = urlPart.startsWith('http')
          ? urlPart
          : `${baseURL.replace(/\/+$/, '')}/${urlPart.replace(/^\/+/, '')}`;

        const response = await fetch(fetchUrl, {
          method: 'PUT',
          headers: config.headers,
          body: formData,
        });

        if (!response.ok && response.status !== 200) {
          const errorText = await response.text();
          throw Object.assign(new Error(), { response: { data: errorText } });
        }
      } catch (error: any) {
        console.log(error);
      }

      // Update comment
      try {
        setLoaderM(true);
        const config_comment: any = {
          method: 'post',
          url: 'resource/Comment',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
          },
          data: {
            comment_type: 'Comment',
            reference_doctype: 'Asset',
            reference_name: pname,
            content: update.comment,
          },
        };
        await axios(config_comment);
      } catch (error: any) {
        console.log(error);
      } finally {
        getAssetIndividual();
        getTimeline();
        setLoaderM(false);
        setQuickupdate(false);
        present({
          message: t('Assets.CreateA.assetUpdateSuccesss'),
          duration: 2000,
        });
        // reset modal
        setUpdate({
          status: '',
          asset_state: '',
          brand: '',
          model: '',
          year: '',
          comment: '',
          asset_component: [],
          attachment: {},
          barcode_id: '',
          old_asset: ''
        });
      }
    } else {
      setQuickupdate(false);
    }
  }

  const openMap = (coordinates: any) => {
    const url = 'https://www.google.com.sa/maps/search/' + coordinates;
    window.open(url, '_blank');
  };

  const closeModal = () => {
    setShowModal(false);
    for (const x in createAssetFields) {
      const f = createAssetFields[x].field;
      if (f === 'project') {
        createAssetFields[x].value = '';
        createAssetFields[x].options = [];
        createAssetFields[x].type = 'select';
        createAssetFields[x].disabled = false;
      } else if (f === 'task') {
        createAssetFields[x].value = '';
        /* Get TASK by PROJECT */
        createAssetFields[x].options = [];
      }
    }
  };

  const getGps = (param: any) => {
    try {
      const geolocation = window.navigator?.geolocation;
      if (geolocation) {
        setLoaderGps(true);
        geolocation.getCurrentPosition(
          async (position) => {
            try {
              const Data = [..._data];
              const latitude = position?.coords?.latitude?.toFixed(6)?.toString();
              const longitude = position?.coords?.longitude?.toFixed(6)?.toString();
              const latLng = Data.findIndex((d) => d.field === param);
              Data[latLng].value = latitude + ', ' + longitude;

              const baseURL = localStorage.getItem('baseUrl') || process.env.REACT_APP_BASE_URL || 'https://admin.hyprism.com/api';

              // find address
              const res = await axios({
                method: 'get',
                url: `${baseURL}/method/preflet_asset.api.get_location?lat=${latitude}&lon=${longitude}`,
                headers: {
                  Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
                },
              });

              const latLngAddress = Data.findIndex((d) => d.field === 'northing_easting_address');
              if (res?.data?.message?.addresses?.length > 0) {
                Data[latLngAddress].value = res?.data?.message?.addresses[0].address.freeformAddress;
                present({
                  message: t(`Assets.CreateA.addressFetchedSuccess`),
                  color: 'success',
                  duration: 2000,
                });
              } else {
                throw new Error('Address not found');
              }
              set_Data(Data);
            } catch (err) {
              console.log('Address fetch error:', err);
              present({
                message: t('Assets.CreateA.addressFetchError', 'Failed to fetch address. Please enter manually.'),
                color: 'warning',
                duration: 3000,
              });
            } finally {
              setLoaderGps(false);
            }
          },
          (error) => {
            console.log('Geolocation error:', error);
            setLoaderGps(false);
            let msg = t('Assets.CreateA.locationError', 'Failed to get location.');
            if (error.code === error.PERMISSION_DENIED) {
              msg = t('Assets.CreateA.locationDenied', 'Location access denied. Please enable it in settings.');
            } else if (error.code === error.TIMEOUT) {
              msg = t('Assets.CreateA.locationTimeout', 'Location request timed out.');
            }
            present({
              message: msg,
              color: 'danger',
              duration: 3000,
            });
          },
          { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
        );
      } else {
        present({
          message: t('Assets.CreateA.geoNotSupported', 'Geolocation is not supported by this browser.'),
          color: 'danger',
          duration: 3000,
        });
      }
    } catch (e: any) {
      console.log('GPS Error:', e);
      setLoaderGps(false);
    }
  };

  const takePicture = async (imageElementIndex: number) => {
    try {
      const image = await Camera.getPhoto({
        quality: 70,
        allowEditing: true,
        resultType: CameraResultType.Uri,
        source: CameraSource.Camera,
      });

      const imageUrl = image.webPath;

      // Can be set to the src of an image now
      const formentry: any = [..._data];
      formentry[imageElementIndex].value = null;
      formentry[imageElementIndex].src = imageUrl;
      formentry[imageElementIndex].format = image.format;
      set_Data(formentry);
    } catch (e: any) {

      console.log('Error: ', e);

      if (e.toString().includes('cancelled')) {

        present({
          message: t('Utils.cameraCancel'),
          color: 'danger',
          duration: 2000,
        });
      }

      else if (e.toString().includes('denied') || e.includes('access')) {

        present({
          message: t('Utils.cameraErrorPermission'),
          color: 'danger',
          duration: 2000,
        });
      } else {

        present({
          message: e,
          color: 'danger',
          duration: 2000,
        });
      }
    }
  };

  const takeQSPicture = async () => {
    try {
      const image = await Camera.getPhoto({
        quality: 70,
        allowEditing: true,
        resultType: CameraResultType.Uri,
        source: CameraSource.Camera,
      });
      const imageUrl = image.webPath;

      // Can be set to the src of an image now
      const formentry: any = { ...update }
      formentry['attachment'].value = null;
      formentry['attachment'].src = imageUrl;
      formentry['attachment'].format = image.format;
      setUpdate(formentry);
    } catch (e: any) {

      console.log('Error: ', e);

      if (e.toString().includes('cancelled')) {

        present({
          message: t('Utils.cameraCancel'),
          color: 'danger',
          duration: 2000,
        });
      }

      else if (e.toString().includes('denied') || e.includes('access')) {

        present({
          message: t('Utils.cameraErrorPermission'),
          color: 'danger',
          duration: 2000,
        });
      } else {

        present({
          message: e,
          color: 'danger',
          duration: 2000,
        });
      }
    }
  };

  /* Remove Image by cross click */
  const emptyImg = (index: number) => {
    const tempData = [..._data];
    if (tempData[index].src) {
      tempData[index].src = '';
    } else if (tempData[index].value) {
      tempData[index].value = '';
    }
    set_Data(tempData);
  };

  /* Remove Quick Status Image by cross click */
  const emptyQSImg = () => {
    const tempData = { ...update };
    tempData.attachment = {};
    setUpdate(tempData);
  };

  const getScan = async (field: any) => {
    const info = await Device.getInfo();
    if (info?.platform === 'web') {
      present({
        message: t('Utils.scannerNotSupported'),
        duration: 2000,
      });
      return
    }
    try {
      BarcodeScanner.isSupported().then((result) => {
        if (!result.supported) {
          present({
            message: t('Utils.unsupportDevice'),
            duration: 2000,
          });
        }
      });

      const granted = await requestPermissions();
      if (!granted) {
        present({
          message: t('Utils.noPermission'),
          duration: 2000,
        });
        return;
      }
      const check = await BarcodeScanner.isGoogleBarcodeScannerModuleAvailable()
      if (!check.available)
        BarcodeScanner.installGoogleBarcodeScannerModule()
      const { barcodes } = await BarcodeScanner.scan();
      const scannedValue = barcodes[0]?.displayValue
      handleScan(scannedValue, field);
    } catch (error: any) {
      console.log(error)
    }
  };

  const handleScan = (data: any, field: any) => {
    if (data) {
      try {
        const tempData = { ...update };
        tempData[field] = data;
        setUpdate(tempData);
      } catch {
        present({
          message: t('Utils.fetchFail'),
          color: 'danger',
          duration: 4000,
        });
        console.log('failed sending id to the parent');
      }
    }
  };

  const getStatusChipStyle = (status: string) => {
    const map: Record<string, { bg: string; color: string }> = {
      Operational: { bg: '#e6f4ea', color: '#2e7d32' },
      'Need Repairing': { bg: '#fff3e0', color: '#e65100' },
      'In Progress': { bg: '#e3f2fd', color: '#1565c0' },
      'Need Replacement': { bg: '#fce4ec', color: '#b71c1c' },
      Replaced: { bg: '#f3e5f5', color: '#6a1b9a' },
      'Need Maintenance': { bg: '#fff8e1', color: '#f57f17' },
      Inactive: { bg: '#f5f5f5', color: '#616161' },
      'Need Installation': { bg: '#e8f5e9', color: '#388e3c' },
      'Installed But Not Operational': { bg: '#ede7f6', color: '#4527a0' },
    };
    return map[status] || { bg: '#e3f2fd', color: '#1565c0' };
  };

  const InfoCard = ({ title, fields }: { title: string; fields: string[] }) => {
    const hasAny = fields.some(k => data[k]);
    if (!hasAny) return null;
    return (
      <div style={{
        margin: '0 1rem 1rem',
        borderRadius: '16px',
        background: '#fff',
        boxShadow: '0 2px 12px rgba(29,80,141,0.07)',
        overflow: 'hidden',
        border: '1px solid #e8edf5',
      }}>
        <div style={{
          background: 'linear-gradient(135deg, #1d508d 0%, #2a6db5 100%)',
          color: 'white',
          padding: '10px 16px',
          fontSize: '12px',
          fontWeight: 700,
          letterSpacing: '1px',
          textTransform: 'uppercase',
        }}>{title}</div>
        <div style={{ padding: '4px 0' }}>
          {fields.map(key => {
            const item = createAssetFields.find((f: any) => f.field === key);
            if (!item) return null;
            const rawVal = data[key];
            if (!rawVal && rawVal !== 0) return null;
            const displayVal: any = item.translate ? t(`Assets.CreateA.${rawVal}`) : rawVal;
            const isLink = key === 'northing_easting_point';
            const isImg = key === 'attachment';
            const isAssetComp = key === 'asset_component';
            return (
              <div key={key} className="asset-detail-row">
                <span className="asset-detail-label">
                  {t(`Assets.CreateA.${key}`)}
                </span>
                <span className="asset-detail-value">
                  {isLink ? (
                    <u style={{ color: '#1d508d', cursor: 'pointer' }} onClick={() => openMap(rawVal)}>{rawVal}</u>
                  ) : isImg ? (
                    <img src={`${localStorage.getItem('baseUrl')?.replace('/api', '')}${rawVal}`} alt="" style={{ width: '80px', borderRadius: '8px', border: '1px solid #e0e0e0' }} />
                  ) : isAssetComp ? (
                    <span>{rawVal?.map((v: any, i: number) => (
                      <Link key={i} to={{ pathname: '/comDetail', state: v.asset_component }}>
                        <u style={{ color: '#1d508d', marginRight: '4px', textTransform: 'capitalize' }}>{v.component_name}</u>
                      </Link>
                    ))}</span>
                  ) : (
                    <span>{displayVal}</span>
                  )}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <IonPage>
      <Header enableBackButton={location.search ? '/' + location.search.replace("?back=", "") : '/all'} title={t('Service.ADet')} />
      <IonModal isOpen={quickupdate} onDidDismiss={() => setQuickupdate(false)}>
        <IonHeader style={{ marginBottom: '2rem' }}>
          <IonToolbar color="primary">
            <p className="text-center">
              <b>{pname}</b>
            </p>
            <IonButtons slot="end">
              <IonButton
                className="line-button"
                onClick={() => {
                  setQuickupdate(false);
                }}
              >
                <IonIcon icon={close} slot="icon-only"></IonIcon>
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonLoading
            isOpen={loaderM}
            onDidDismiss={() => setLoaderM(false)}
            message={t('Utils.pleasewait')}
          />
          <form onSubmit={(e) => SubmitStatusUpdate(e)}>
            {_data.map((form_field: any, index: any) => {
              // if (form_field.field === 'asset_component') {
              //   return (
              //     <div key={index} className="input-container">
              //       <label className="label">{t(`Assets.CreateA.${form_field.field}`)}</label>
              //       <IonSelect
              //         id={`${form_field.field}_choice`}
              //         className="custom-ion-select"
              //         multiple
              //         interface='popover' style={{ color: '#1d508d', fontSize: '14px' }} placeholder='Change Status'
              //         onIonChange={(e) => handleMultiSelectChange(e.detail.value)}
              //         value={update[form_field.field]}
              //       >
              //         {form_field.options?.map(function (opt: any, indexSelect: any) {
              //           return (
              //             <IonSelectOption value={

              //               opt.id}
              //               key={`${form_field.field}-${indexSelect}`}
              //               id={
              //                 `${opt.id}_item_${indexSelect}`}>{opt.label}</IonSelectOption>
              //           );
              //         })}
              //       </IonSelect>
              //     </div>
              //   );
              // }
              //  else
              if (form_field.field === 'status' || form_field.field === 'asset_state') {
                return (
                  <div key={index} className="input-container">
                    <label className="label">{t(`Assets.CreateA.${form_field.field}`)}</label>
                    {form_field.required ? '*' : null}
                    <Select
                      className="custom-select"
                      required={form_field.required}
                      id={`${form_field.field}_choice`}
                      name={form_field.field}
                      onChange={handleUpdateStatus}
                      value={update[form_field.field]}
                      disabled={form_field.disabled || false}
                      key={`${form_field.field}-${index}`}
                    >
                      {form_field.options?.map(function (opt: any, index: any) {
                        return (
                          <MenuItem value={`${opt}`} key={`${form_field.field}-${index}`}>
                            <section key={`${form_field.field}-${index}`} style={{ display: 'flex', height: '1rem' }}>
                              <p
                                key={`${form_field.field}-${index}`}
                                style={{
                                  color: 'rgba(31, 87, 148, 1)',
                                  marginLeft: '0.2rem',
                                  fontSize: '12px',
                                  marginTop: '0px',
                                }}
                              >
                                {form_field.translate ? t(`Assets.CreateA.${opt}`) : opt}
                              </p>
                            </section>
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </div>
                );
              } else if (form_field.field === 'brand' || form_field.field === 'model' || form_field.field === 'year') {
                return (
                  <div key={index} className="input-container">
                    <label className="label">{t(`Assets.CreateA.${form_field.field}`)}
                      {form_field.required ? '*' : null}</label>
                    <input
                      className="basic-input"
                      required={false}
                      key={`${form_field.field}-${index}`}
                      id={form_field.field}
                      placeholder={t(`Assets.CreateA.${form_field.field}`)}
                      onChange={handleChangeQuickUpdate}
                      value={update[form_field.field]}
                    />
                  </div>
                );
              } else if (form_field.type === 'file') {
                return (
                  <div
                    id={`${form_field.field}-${index}`}
                    className="input-container"
                    key={`${form_field.field}-${index}`}
                  >
                    <label id={`label-${form_field.field}`} className="label">
                      {t(`Assets.CreateA.${form_field.field}`)}
                      {form_field.required ? '*' : null}{' '}
                    </label>
                    <IonButton
                      style={{ marginTop: '1rem', margin: 'auto', width: '40%', color: 'black', marginBottom: '1rem' }}
                      size="small"
                      color="light"
                      onClick={() => takeQSPicture()}
                    >
                      {
                        update[form_field.field]['value'] ? t('Utils.change_image') : t('Utils.image')}
                    </IonButton>
                    <div className="flex justify-center items-center">
                      {
                        update[form_field.field]['value'] ? (
                          <img
                            src={`${localStorage.getItem('baseUrl')?.replace('/api', '')}${update[form_field.field]['value']}`}
                            alt=""
                            style={{
                              width: '60%',
                              margin: 'auto',
                              display: 'block',
                              border: '1px solid lightgray',
                              borderRadius: '12px',
                            }}
                          />
                        ) : (
                          ''
                        )}
                      {
                        update['attachment']['src'] ? <img className="preview-survey-img" src={update['attachment']['src']} alt="" /> : ''}
                      {
                        update['attachment']['src'] ? (
                          <IonIcon className="close-icon" onClick={() => emptyQSImg()} src={close} />
                        ) : (
                          ''
                        )}
                    </div>
                  </div>
                );
              } else if (form_field.type === 'barcode') {
                return (
                  <div
                    id={`${form_field.field}-${index}`}
                    className="input-container"
                    key={`${form_field.field}-${index}`}
                  >
                    <label id={`label-${form_field.field}`} style={{ marginTop: '1rem' }} className="label">
                      {t(`Assets.CreateA.${form_field.field}`)}
                      {form_field.required ? '*' : null}{' '}
                    </label>
                    <div className="flex items-center justify-between basic-input">
                      <input
                        required={form_field.required}
                        className="gps-input"
                        id={form_field.field}
                        placeholder={t(`Assets.CreateA.${form_field.field}`)}
                        value={
                          update[form_field.field]}
                        disabled={true}
                        style={{ width: '80%' }}
                      />
                      <IonIcon onClick={() => getScan(form_field.field)} className="gps-icon" src={barcodeOutline} />
                    </div>
                  </div>
                );
              }
            })}
            <div className="input-container">
              <label className="label">{t(`Utils.Comment`)}</label>
              <textarea
                className="textarea"
                required={false}
                key="comment"
                id="comment"
                placeholder={t('Utils.Add your comment')}
                onChange={handleChangeQuickUpdate}
                value={update.comment}
              />
            </div>
            <button className="submit-button" type="submit">
              {t(`Assets.CreateA.update`)}
            </button>
          </form>
        </IonContent>
      </IonModal>

      <IonModal isOpen={showModal} onDidDismiss={() => closeModal()}>
        <IonLoading
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={t('Utils.pleasewait')}
          duration={showModal ? 1000 : 5000}
        />
        <IonHeader>
          <IonToolbar color="primary">
            <IonTitle>
              {t(`Assets.CreateA.edit`)} {data.asset_name}{' '}
            </IonTitle>
            <IonButtons slot="end">
              <IonButton
                className="line-button"
                onClick={() => {
                  for (const x in _data) {
                    _data[x].value = '';
                  }
                  setShowModal(false);
                }}
              >
                <IonIcon icon={close} slot="icon-only"></IonIcon>
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding">
          <form onSubmit={(e) => Submit(e)}>
            {_data.map((form_field: any, index: any) => {
              if (form_field.title) {
                return (
                  <p key={index} className="form-title">
                    {t(form_field.title)}
                  </p>
                );
              } else if (form_field.type === 'text' || form_field.type === 'number') {
                return (
                  <div key={index} className="input-container">
                    <label className="label">
                      {t(`Assets.CreateA.${form_field.field}`)}
                      {form_field.required ? '*' : null}
                    </label>
                    {form_field.field === 'northing_easting_point' ? (
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        background: '#fff',
                        borderRadius: '12px',
                        border: '1px solid #e8edf5',
                        padding: '4px 6px 4px 12px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.03)',
                        transition: 'all 0.2s ease',
                        marginTop: '8px'
                      }}>
                        <input
                          required={form_field.required}
                          style={{
                            flex: 1,
                            border: 'none',
                            outline: 'none',
                            fontSize: '14px',
                            color: '#333',
                            padding: '10px 0',
                            background: 'transparent'
                          }}
                          id={form_field.field}
                          placeholder={t(`Assets.CreateA.${form_field.field}`)}
                          onChange={handleChange}
                          value={form_field.value}
                        />
                        {loaderGps && (
                          <div style={{ margin: '0 8px' }}>
                            <IonSpinner name="crescent" style={{ width: '20px', height: '20px', color: '#1d508d' }} />
                          </div>
                        )}
                        <button
                          type="button"
                          onClick={() => getGps(form_field.field)}
                          disabled={loaderGps}
                          style={{
                            background: 'linear-gradient(135deg, #1d508d 0%, #0f3460 100%)',
                            color: 'white',
                            borderRadius: '10px',
                            padding: '10px 14px',
                            fontSize: '12px',
                            fontWeight: 700,
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            border: 'none',
                            boxShadow: '0 4px 10px rgba(29,80,141,0.2)',
                            cursor: 'pointer',
                            opacity: loaderGps ? 0.6 : 1
                          }}
                        >
                          {/* Reuse Gps icon if available, otherwise just text */}
                          <span style={{ fontSize: '12px', fontWeight: 700 }}>{t('Utils.getGps', 'GPS')}</span>
                        </button>
                      </div>
                    ) : (
                      <div style={{ display: 'flex', alignItems: 'center', position: 'relative', marginTop: '8px', width: '100%' }}>
                        <input
                          required={form_field.required}
                          className="basic-input"
                          style={{
                            marginTop: 0,
                            background: form_field.disabled ? '#F1F7F5' : '',
                            width: '100%'
                          }}
                          key={`${form_field.field}-${index}`}
                          id={form_field.field}
                          type={form_field.type}
                          placeholder={t(`Assets.CreateA.${form_field.field}`)}
                          onChange={handleChange}
                          value={form_field.value}
                          disabled={form_field.disabled || false}
                        />
                        {form_field.field === 'northing_easting_address' && loaderGps && (
                          <IonSpinner
                            style={{ position: 'absolute', right: '1rem', top: '50%', transform: 'translateY(-50%)', width: '20px', height: '20px', color: '#1d508d' }}
                            name="crescent"
                          />
                        )}
                      </div>
                    )}
                  </div>
                );
              } else if (form_field.type === 'textarea') {
                return (
                  <div key={index} className="input-container">
                    <label className="label">
                      {t(`Assets.CreateA.${form_field.field}`)}
                      {form_field.required ? '*' : null}
                    </label>
                    <textarea
                      className="textarea"
                      required={form_field.required}
                      key={`${form_field.field}-${index}`}
                      id={form_field.field}
                      placeholder={t(`Assets.CreateA.${form_field.field}`)}
                      onChange={handleChange}
                      value={form_field.value}
                    />
                  </div>
                );
              } else if (form_field.type === 'select') {
                return (
                  <div key={index} className="input-container">
                    <label className="label">
                      {t(`Assets.CreateA.${form_field.field}`)}
                      {form_field.required ? '*' : null}
                    </label>
                    <Select
                      className="custom-select"
                      required={form_field.required}
                      id={`${form_field.field}_choice`}
                      name={form_field.field}
                      onChange={handleSelectChange}
                      value={form_field.value}
                      disabled={form_field.disabled || false}
                      key={`${form_field.field}-${index}`}
                    >
                      {form_field.options?.map(function (opt: any, indexSelect: any) {
                        return (
                          <MenuItem
                            value={`${opt}`}
                            key={`${form_field.field}-${indexSelect}`}
                            id={`${opt}_item_${indexSelect}`}
                          >
                            <section
                              key={`${form_field.field}-${indexSelect}`}
                              style={{ display: 'flex', height: '1rem' }}
                            >
                              <p
                                style={{
                                  color: 'rgba(31, 87, 148, 1)',
                                  marginLeft: '0.2rem',
                                  fontSize: '12px',
                                  marginTop: '0px',
                                }}
                              >
                                {form_field.translate ? t(`Assets.CreateA.${opt}`) : opt}
                              </p>
                            </section>
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </div>
                );
              } else if (form_field.type === 'multi-select') {
                return (
                  <div
                    id={`${form_field.field}-${index}`}
                    className="input-container"
                    key={`${form_field.field}-${index}`}
                  >
                    <label id={`label-${form_field.field}`} className="label">
                      {t(`Assets.CreateA.${form_field.field}`)}
                      {form_field.required ? '*' : null}{' '}
                    </label>
                    {form_field.info ? (
                      <div className="tooltip">
                        <IonIcon style={{ marginBottom: '-4px' }} src={informationCircle} />
                        <span className="tooltiptext">{t(`Utils.${form_field.info}`)}</span>
                      </div>
                    ) : null}
                    <div style={{ display: 'flex', flexWrap: 'wrap', padding: '2px', marginLeft: '14px' }}>
                      {Object.values(form_field.value).map((val: any, key) => {
                        return (
                          <p key={key} style={{ fontSize: '10px', color: 'blue', textDecoration: 'underline', cursor: 'pointer', marginRight: '0.6rem' }}>
                            <Link to={{ pathname: '/comDetail', state: val.id }}>{val.label}</Link>
                          </p>
                        )
                      })}
                    </div>
                    <IonSelect
                      id={`${form_field.field}_choice`}
                      className="custom-ion-select"
                      multiple
                      interface='popover' style={{ color: '#1d508d', fontSize: '14px' }} placeholder='Asset components'
                      onIonChange={(e) => handleMultiSelectChangeEdit(e.detail.value)}
                      value={form_field.value || []}
                    >
                      {form_field.options?.map(function (opt: any, indexSelect: any) {
                        return (
                          <IonSelectOption value={

                            opt.id}
                            key={`${form_field.field}-${indexSelect}`}
                            id={
                              `${opt.id}_item_${indexSelect}`}>{opt.label}</IonSelectOption>
                        );
                      })}
                    </IonSelect>
                  </div>
                );
              }
              else if (form_field.type === 'file') {
                return (
                  <div
                    id={`${form_field.field}-${index}`}
                    className="input-container"
                    key={`${form_field.field}-${index}`}
                  >
                    <label id={`label-${form_field.field}`} className="label">
                      {t(`Assets.CreateA.${form_field.field}`)}
                      {form_field.required ? '*' : null}{' '}
                    </label>
                    <IonButton
                      style={{ marginTop: '1rem', margin: 'auto', width: '40%', color: 'black', marginBottom: '1rem' }}
                      size="small"
                      color="light"
                      onClick={() => takePicture(index)}
                    >
                      {form_field.src || form_field.value ? t('Utils.change_image') : t('Utils.image')}
                    </IonButton>
                    <div className="flex justify-center items-center">
                      {form_field.value ? (
                        <img
                          src={`${localStorage.getItem('baseUrl')?.replace('/api', '')}${form_field.value}`}
                          alt=""
                          style={{
                            width: '40%',
                            margin: 'auto',
                            display: 'block',
                            border: '1px solid lightgray',
                            borderRadius: '12px',
                          }}
                        />
                      ) : (
                        ''
                      )}
                      {form_field['src'] ? <img className="preview-survey-img" src={form_field['src']} alt="" /> : ''}
                      {form_field['src'] ? (
                        <IonIcon className="close-icon" onClick={() => emptyImg(index)} src={close} />
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                );
              }
              else if (form_field.type === 'date' || form_field.type === 'datetime-local') {
                return (
                  <div key={index} className="input-container">
                    <label className="label">
                      {t(`Assets.CreateA.${form_field.field}`)}
                      {form_field.required ? '*' : null}
                    </label>
                    <input
                      required={form_field.required}
                      className="date"
                      key={`${form_field.field}-${index}`}
                      id={form_field.field}
                      placeholder={t(`Assets.CreateA.${form_field.field}`)}
                      onChange={handleChange}
                      value={form_field.value}
                      type={form_field.type}
                    />
                  </div>
                );
              } else {
                return '';
              }
            })}
            <button className="submit-button" type="submit">
              {t(`Assets.CreateA.save`)}
            </button>
          </form>
        </IonContent>
      </IonModal>
      <IonContent>
        {/* Hero Banner */}
        <div style={{
          background: 'linear-gradient(135deg, #1d508d 0%, #2a6db5 100%)',
          padding: '1.25rem 1rem 1.5rem',
          color: 'white',
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '1.5px', opacity: 0.7, margin: '0 0 4px' }}>
                {t('Assets.Asset')}
              </p>
              <h2 style={{ margin: 0, fontSize: '18px', fontWeight: 700, wordBreak: 'break-word' }}>{data.name}</h2>
              {data.asset_name && data.asset_name !== data.name && (
                <p style={{ margin: '4px 0 0', fontSize: '13px', opacity: 0.8 }}>{data.asset_name}</p>
              )}
              {data.status && (() => {
                const chip = getStatusChipStyle(data.status);
                return (
                  <span style={{
                    display: 'inline-block',
                    marginTop: '10px',
                    padding: '4px 12px',
                    borderRadius: '20px',
                    background: chip.bg,
                    color: chip.color,
                    fontSize: '11px',
                    fontWeight: 700,
                  }}>{t(`Utils.${data.status}`) || data.status}</span>
                );
              })()}
            </div>
            <div style={{ display: 'flex', gap: '6px', marginLeft: '8px' }}>
              {!!state.permissions.assets_update && (
                <button
                  onClick={() => { setPname(data.name); quickStatus(); }}
                  style={{
                    background: 'rgba(255,255,255,0.15)',
                    border: '1px solid rgba(255,255,255,0.3)',
                    borderRadius: '10px',
                    color: 'white',
                    padding: '8px 10px',
                    cursor: 'pointer',
                    backdropFilter: 'blur(4px)',
                    fontSize: '18px',
                    lineHeight: 1,
                  }}
                >
                  <IonIcon src={constructOutline} />
                </button>
              )}
              {!!state.permissions.assets_update && (
                <button
                  onClick={() => edit()}
                  style={{
                    background: 'rgba(255,255,255,0.15)',
                    border: '1px solid rgba(255,255,255,0.3)',
                    borderRadius: '10px',
                    color: 'white',
                    padding: '8px 10px',
                    cursor: 'pointer',
                    backdropFilter: 'blur(4px)',
                    fontSize: '18px',
                    lineHeight: 1,
                  }}
                >
                  <IonIcon src={createOutline} />
                </button>
              )}
              {data.barcode_id && (
                <button
                  onClick={() => setShowQr(true)}
                  style={{
                    background: 'rgba(255,255,255,0.15)',
                    border: '1px solid rgba(255,255,255,0.3)',
                    borderRadius: '10px',
                    color: 'white',
                    padding: '8px 10px',
                    cursor: 'pointer',
                    backdropFilter: 'blur(4px)',
                    fontSize: '18px',
                    lineHeight: 1,
                  }}
                >
                  <IonIcon src={barcodeOutline} />
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Category + Type quick pills */}
        {(data.asset_category || data.asset_type) && (
          <div style={{ display: 'flex', gap: '8px', padding: '12px 1rem 0', flexWrap: 'wrap' }}>
            {data.asset_category && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', background: '#f0f4ff', borderRadius: '8px', padding: '6px 12px' }}>
                {color && <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: color.color, flexShrink: 0 }} />}
                <span style={{ fontSize: '12px', color: '#1d508d', fontWeight: 600 }}>{data.asset_category}</span>
              </div>
            )}
            {data.asset_type && (
              <div style={{ background: '#f5f0ff', borderRadius: '8px', padding: '6px 12px' }}>
                <span style={{ fontSize: '12px', color: '#5c35a0', fontWeight: 600 }}>{data.asset_type}</span>
              </div>
            )}
          </div>
        )}

        <div style={{ padding: '12px 0 0' }}>
          <InfoCard
            title={t('Assets.Categories.details', 'Details')}
            fields={['asset_description', 'brand', 'model', 'year', 'power', 'asset_owner', 'project', 'installation_datetime', 'target_date', 'remarks', 'attachment']}
          />
          <InfoCard
            title={t('Assets.Categories.identification', 'Identification')}
            fields={['equipment_number', 'barcode_id', 'pt_number', 'old_asset', 'old_asset_description']}
          />
          <InfoCard
            title={t('Assets.Categories.location', 'Location')}
            fields={['control_unit', 'northing_easting_address', 'northing_easting_point', 'geo_act_id']}
          />
          <InfoCard
            title={t('Assets.Categories.index', 'Index')}
            fields={['health_index', 'risk_index']}
          />
        </div>

        {/* Timeline */}
        {timeline.length > 0 && (
          <div style={{ margin: '0 1rem 1rem', borderRadius: '16px', background: '#fff', boxShadow: '0 2px 12px rgba(29,80,141,0.07)', overflow: 'hidden', border: '1px solid #e8edf5' }}>
            <div style={{ background: 'linear-gradient(135deg, #1d508d 0%, #2a6db5 100%)', color: 'white', padding: '10px 16px', fontSize: '12px', fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase' }}>
              {t('Utils.Timeline', 'Timeline')}
            </div>
            <div style={{ padding: '12px 16px' }}>
              {timeline.map((item: any, i: number) => (
                <div key={i}>{returnTimeline(item)}</div>
              ))}
            </div>
          </div>
        )}

        {/* QR Modal */}
        <IonModal isOpen={showQr} onDidDismiss={() => setShowQr(false)}>
          <IonHeader style={{ marginBottom: '2rem' }}>
            <IonToolbar color="primary">
              <IonTitle style={{ display: 'flex', itemAlign: 'center' }}>
                <IonIcon src={barcodeSharp} /> <span>{data.asset_name}</span>
              </IonTitle>
              <IonButtons slot="end">
                <IonButton
                  className="line-button"
                  onClick={() => { setShowQr(false); }}
                >
                  <IonIcon icon={close} slot="icon-only"></IonIcon>
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <div className="flex justify-center">
              <div id="download-qr-code">
                <Barcode className="qr-code" style={{ margin: '1rem' }} value={data.barcode_id || ""} width={1} />
              </div>
            </div>
          </IonContent>
        </IonModal>

        <div style={{ height: '3rem' }}></div>
      </IonContent>
    </IonPage>
  );
};

export default AssetDet;
